export const questions = [
    {
        id: 0,
        question: 'Du köper en vara för 212 kr inkl. 6 % moms. Vad är priset exkl. moms?',
        options: [
            { text: '190 kr', isCorrect: false },
            { text: '199 kr', isCorrect: false },
            { text: '200 kr', isCorrect: true },
            { text: '206 kr', isCorrect: false }
        ]
    },
    {
        id: 1,
        question: 'Nästa nummer',
        questionText: 'Vilket tal kommer näst i serien? 10, 15, 25, 40, ?',
        options: [
            { text: '50', isCorrect: false },
            { text: '55', isCorrect: false },
            { text: '60', isCorrect: true },
            { text: '70', isCorrect: false }
        ]
    },
    {
        id: 2,
        question: 'Om 6 personer målar 6 rum på 6 timmar, hur många timmar tar det för 12 personer att måla 12 rum i samma tempo?',
        options: [
            { text: '3 timmar', isCorrect: false },
            { text: '6 timmar', isCorrect: true },
            { text: '12 timmar', isCorrect: false },
            { text: '24 timmar', isCorrect: false }
        ]
    },
    {
        id: 3,
        question: 'Försäljningspris minus rörlig kostnad per styck ger...?',
        options: [
            { text: 'Täckningsbidrag per styck', isCorrect: true },
            { text: 'Vinstmarginal', isCorrect: false },
            { text: 'Självkostnad', isCorrect: false },
            { text: 'Nollpunktsvolym', isCorrect: false }
        ]
    },
    {
        id: 4,
        question: 'Vad blir nettoperiodiseringsfonden i ett aktiebolag som vill sätta av maximalt tillåtna 25 % av sitt resultat före skatt om resultatet är 400 000 kr?',
        options: [
            { text: '50 000 kr', isCorrect: false },
            { text: '80 000 kr', isCorrect: false },
            { text: '100 000 kr', isCorrect: true },
            { text: '120 000 kr', isCorrect: false }
        ]
    },
    {
        id: 5,
        question: 'Utslagsfråga – närmast vinner',
        questionText: 'Vilken är den exakta ordinarie bolagsskattesatsen i Sverige?',
        isTiebreaker: true,
        placeholder: 'Ange procent',
        options: []
    }
]
